import { render, staticRenderFns } from "./uwesForm.vue?vue&type=template&id=ddf97afe&scoped=true"
import script from "./uwesForm.vue?vue&type=script&lang=js"
export * from "./uwesForm.vue?vue&type=script&lang=js"
import style0 from "./uwesForm.vue?vue&type=style&index=0&id=ddf97afe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf97afe",
  null
  
)

export default component.exports